export class AuditLogExtendedData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "auth",
            "baseName": "auth",
            "type": "AuditLogExtendedDataAuth",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogExtendedData.attributeTypeMap;
    }
    constructor() {
    }
}
